module.exports = __webpack_public_path__ + "img/invoice-err.65e51ba2.svg";